import { render } from "./templates/index.html?vue&type=template&id=4a925c2d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./styles/dropdown.scss?vue&type=style&index=0&id=4a925c2d&scoped=true&lang=scss"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a925c2d"]])

export default __exports__